<template>
  <div
    class="border-situational-lightgrey flex flex-col space-y-4 rounded-[20px] border px-3 py-2"
  >
    <textarea
      id="ai-chat-text-area"
      :value="messageText"
      name="ai-chat-textarea"
      :placeholder="$t('aiChat.message')"
      class="text-text-neutral-primary placeholder:text-situational-darkgrey bg-background-neutral-primary w-full resize-none caret-green-500 outline-none"
      :rows="dynamicRows"
      @input="handleInput"
    ></textarea>
    <div class="flex items-end justify-end">
      <button
        type="button"
        class="rounded-full p-2 duration-75"
        :class="
          isLoading
            ? 'bg-background-neutral-tertiary pointer-events-none'
            : 'bg-green-500'
        "
        :disabled="isLoading"
        @click="emit('onSubmit')"
      >
        <img
          src="./assets/letter-icon.svg"
          :alt="$t('general.submit')"
          width="16"
          height="16"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  import { MIN_TEXTAREA_ROWS, MAX_TEXTAREA_ROWS } from '../config';

  const props = defineProps<{
    messageText: string;
    isLoading?: boolean;
  }>();

  const emit = defineEmits<{
    onInput: [string];
    onSubmit: [];
  }>();
  const dynamicRows = ref(MIN_TEXTAREA_ROWS);

  const handleInput = (e: Event) => {
    emit('onInput', e.target.value);

    setTimeout(() => {
      const textarea = document.getElementById(
        'ai-chat-text-area',
      ) as HTMLTextAreaElement;
      if (!textarea) {
        return;
      }

      const textareaWidth = textarea.clientWidth;

      // Вычисляем примерное количество символов в строке
      // Для шрифта 16px примерно 8-10 пикселей на символ (зависит от шрифта)
      const charWidth = 8; // приблизительная ширина символа в пикселях
      const charsPerLine = Math.floor(textareaWidth / charWidth);

      const lines = props.messageText.split('\n');

      let totalLines = 0;
      lines.forEach(line => {
        if (line.length === 0) {
          totalLines += 1; // пустая строка
        } else {
          // Количество строк для данной линии с учетом переносов
          totalLines += Math.ceil(line.length / charsPerLine);
        }
      });

      dynamicRows.value = Math.max(
        MIN_TEXTAREA_ROWS,
        Math.min(MAX_TEXTAREA_ROWS, totalLines),
      );
    });
  };
</script>
